import { transformDate } from '@U/filter'

export function getLastNDay(n = 1, currentDate) { // n 表示前几天， currentDate 表示指定的当前时间
  const day = currentDate ? new Date(currentDate) : new Date()
  day.setDate(day.getDate() - n)
  return transformDate(day, 'yyyy-MM-dd')
}

export function getNextNDay(n = 0, currentDate) { // n 表示后几天，0表示当前天， currentDate 表示指定的当前时间
  const day = currentDate ? new Date(currentDate) : new Date()
  day.setDate(day.getDate() + n)
  return transformDate(day, 'yyyy-MM-dd')
}

